<template>
  <AboutSection />
</template>

<script>
import AboutSection from '../components/sections/AboutSection.vue'

export default {
  name: 'AboutPage',
  components: {
    AboutSection
  }
}
</script>
